import React from 'react';

const Unsubscribed = () => <span className="status unsubscribed-plan"> Trial</span>
const Subscribed = () => <span className="status paid-plan"> Premier</span>
const FreeSubscription = () => <span className="status free-plan"> Free</span>

const SubscriptionStatus = ({ active_payment, free_subscription }) => {
  if (active_payment) { return <Subscribed /> }
  if (free_subscription) { return <FreeSubscription /> }

  return <Unsubscribed />
}

export default SubscriptionStatus



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/SubscriptionStatus.js